import { render, staticRenderFns } from "./batchUpdateVoice.vue?vue&type=template&id=617e4c87&scoped=true&"
import script from "./batchUpdateVoice.vue?vue&type=script&lang=js&"
export * from "./batchUpdateVoice.vue?vue&type=script&lang=js&"
import style0 from "./batchUpdateVoice.vue?vue&type=style&index=0&id=617e4c87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e4c87",
  null
  
)

export default component.exports